/** Shown in place of a page that failed to load or render. The header and footer keep working. */
export function PageFailed() {
  return (
    <section className="notfound">
      <div className="wrap">
        <div className="glass page-failed" role="alert">
          <div className="eyebrow">Couldn't load this page</div>
          <h1>Something didn't <em className="s">load right.</em></h1>
          <p>Check your connection and try again. If it keeps happening, write to hello@getmauj.com.</p>
          <div className="ctas">
            <button type="button" className="btn gold" onClick={() => window.location.reload()}>Try again</button>
            <a className="btn clear" href="/">Go to the home page</a>
          </div>
        </div>
      </div>
    </section>
  )
}
